var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorDialogV2',{attrs:{"value":_vm.show,"title":"Are you sure you want to delete the selected groups?","confirmButtonText":"Delete","cancelButtonText":"Don't delete","showCancelButton":true},on:{"input":function($event){return _vm.$emit('update:show', $event)},"confirm":function($event){return _vm.$emit('delete')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }